import { createStore } from 'owa-satcheljs';
import type AppModuleStore from './schema/AppModuleStore';

const getAppModuleStore: () => AppModuleStore = createStore<AppModuleStore>('appModule', {
    module: undefined,
});

export default getAppModuleStore;
